<template>
    <div id="pricing" class="">
        <div class="mb--25">
            <CustomText size="lg" color="gray-800" transform="capitalize" weight="semi--bold">
                Pricing Plans
            </CustomText>
    
            <div>
                <div class="flex align-items-center">
                    <span class="text--sm mr--3">Find a plan based on your freelancer needs. For more questions on our pricing plans, go to our</span>
                    <span class="text--sm">
                        <router-link to="/support" target="_blank" class="text--medium text--color-primary text--underline">
                            support page 
                        </router-link>
                    </span>
                    <span>
                        <IconSvg
                            name="external-link" 
                            class="earning-icon-link" 
                            width="14px" 
                            height="14px"
                            fill="#1d191673"
                        />
                    </span>
                </div>
            </div>
        </div>

        <Plans 
            type="inner" 
            :active-plan="accountPlan"
            :loading="btnLoading"
            :currency="currency"
            :btn-disabled="subscriptionInfo.status === 'switch_pending' || subscriptionInfo.status === 'pending'"
            @set-plan="handleContinue"
        />
    </div>
</template>

<script>
import { Plans, IconSvg, CustomText } from "@/components/ui/index";
import { pricingInfoData } from "@/utils/dummy";
import { convertNumStringToNum } from "@/utils/numbers";

export default {
    name: "BillingsPage",

    components: {
        Plans,
        IconSvg,
        CustomText,
    },

    props: {
        title: { type: String, default: "" },
        desc: { type: String, default: "" },
        highlight: { type: String, default: "" },
        btnLabel: { type: String, default: "Reload" },
        iconName: { type: String, default: "reload" },
    },

    data() {
        return {
            requestLoading: false,
            continueRequestLoading: false,
            pageLoading: false,
            pricingInfoData,
            btnLoading: false,
        };
    },

    computed: {
        subscriptionInfo() {
            return this.$store.getters["subscription/subscriptionInfo"];
        },

        accountPlan() {
            return this.subscriptionInfo?.plan || "free";
        },

        systemPlans() {
            return this.$store.getters["config/systemPlans"];
        },

        profile() {
            return this.$store.getters["auth/profile"];
        },

        currency() {
            return this.$store.getters["settings/general"]?.currency;
        },
    },

    methods: {
        getPlanInfo(plan) {
            return this.$format_amount(this.systemPlans[plan?.toLowerCase()]?.amount[this.subscriptionInfo?.currency]?.monthlyAmount, 2) || 0;
        },

        async handleContinue(plan) {
            try {
                this.btnLoading = true;
                this.selectedPlan = plan;

                const amount = this.getPlanInfo(plan);
                
                if (!plan) {
                    this.$toast.error("Please select a plan");
                    return;
                }  
                
                if (plan === this.accountPlan) {
                    this.$toast.error("Please select a different plan");
                    return;
                }  

                const payload = {
                    email: this.profile.email,
                    targetPlan: plan,
                    amount: convertNumStringToNum(amount),
                    metadata: JSON.stringify({
                        cancel_action: `${window.location.origin}/dashboard/settings/plans`,
                    }),
                    callback_url: `${window.location.origin}/payments/verify`,
                };

                const data = await this.$store.dispatch("subscription/updateSubscriptionPlan", payload);

                if (data?.url) {
                    sessionStorage.setItem("z:t_p", plan);
                    sessionStorage.setItem("z:t_type", "dcdahsygh");

                    window.location.href = data.url;
                    return;
                }

                if (!plan !== "free") {
                    this.$emit("refresh-payment-list", true);
                }

                if (data.subscription.status === "switch_pending") {
                    this.$router.push("/dashboard/settings/payments-and-billings");
                }
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;
                this.$toast.error(errMsg);
            } finally {
                this.btnLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
   .plan {
        &__heading {
            margin-top: 2rem;
            margin-bottom: 2rem;
        }

        &__title {
            font-size: 1.5rem;
            font-weight: 600;
            margin-bottom: 5px;
        }
   }
</style>